import { Box } from '@mui/material';
import React from 'react';
import LogosListSvg from '../../shared/LogosListSvg/LogosListSvg';
import Section from '../../shared/Section/Section';

function News({ title, subtitle, data: { list } }) {
  return (
    <Section title={title} subtitle={subtitle} theme="dark" withoutBg>
      <Box
        sx={{
          paddingTop: {
            xs: '8px',
            xl: '0',
          },
        }}
      >
        <LogosListSvg list={list} />
      </Box>
    </Section>
  );
}

export default News;
